import { Form } from 'formik';
import React from 'react';
import { FederalRuleCitingSection } from '../../components/citing/FederalRuleCiting';
import { RecommendationBar } from '../../components/Shared';
import { useWritingForm } from '../../hooks/useWritingForm';
import { SourceType } from '../../types';
import { SECTION_TITLE, TestIds } from './constants';
import GenericSection from '../../components/GenericSection';
import { MoreOptionsSection } from '../../components/MoreOptions';
import { PUB_FEDERAL_INFO_SECTION_FIELD_LIST } from './constants/fieldList';
import { PubMainTypeEnum } from '../../types';
var FederalRuleForm = function FederalRuleForm() {
  useWritingForm(SourceType.FEDERAL_RULE);
  return /*#__PURE__*/React.createElement(Form, {
    "data-test": TestIds.FEDERAL_RULE_FORM
  }, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(FederalRuleCitingSection, null), /*#__PURE__*/React.createElement(GenericSection, {
    fieldList: PUB_FEDERAL_INFO_SECTION_FIELD_LIST,
    name: PubMainTypeEnum.PUB_FEDERAL,
    sectionTitle: SECTION_TITLE,
    "data-test": TestIds.FEDERAL_RULE_PUB_INFO,
    selectedTab: ''
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null));
};
export default FederalRuleForm;